'use client';

import '@ui5/webcomponents-fiori/dist/SideNavigationItem.js';
import { withWebComponent } from '../../internal/withWebComponent.js';
/**
 * The `SideNavigationItem` is used within `SideNavigation` only. Via the `SideNavigationItem` you control the content of the `SideNavigation`.
 *
 * @abstract
 *
 * __Note:__ This component is a web component developed by the UI5 Web Components’ team.
 *
 * [UI5 Web Components Storybook](https://sap.github.io/ui5-webcomponents/playground/?path=/docs/fiori-SideNavigation)
 */
const SideNavigationItem = withWebComponent('ui5-side-navigation-item', ['href', 'icon', 'target', 'text'], ['expanded', 'wholeItemToggleable', 'selected'], [], ['click']);
SideNavigationItem.displayName = 'SideNavigationItem';
export { SideNavigationItem };